export interface LoginResponse {
  success: boolean;
  forward: string | null;
}

export const login = async (
  email: string,
  password: string,
  rememberMe: boolean,
  forward: string | null,
): Promise<LoginResponse> => {
  try {
    const response = await fetch('/login', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrerPolicy: 'strict-origin-when-cross-origin',
      body: JSON.stringify({
        username: email,
        password,
        rememberMe,
        forward,
        schoolId: null,
        timezoneOffset: new Date().getTimezoneOffset(),
      }),
    });

    if (!response.ok) {
      return handleUnexpectedError(forward);
    }

    const result = await response.json();

    return {
      success: result?.success,
      forward: result?.forward,
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return handleUnexpectedError(forward);
  }
};

const handleUnexpectedError = (forward: string | null): LoginResponse => ({
  success: false,
  forward,
});
